import { API_BASE_URL } from 'src/app/core/providers/constants/api.constants';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  DailyPlanningApiRoutesDto,
  ResponsePlanningRecordByDay,
} from '../dto/daily-planning.dto';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteDailyPlanningService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/daily-planning`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  updateDailyPlanning(body: {
    workOrderId: number;
    quantity: number;
  }): Observable<ResponsePlanningRecordByDay> {
    return this.http.patch<ResponsePlanningRecordByDay>(
      `${this.urlRoute}/day/validate/${body.workOrderId}`,
      body
    );
  }

  createOneRecord(
    body: DailyPlanningApiRoutesDto['createPlanningQuantity']['body']
  ): Observable<DailyPlanningApiRoutesDto['createPlanningQuantity']['return']> {
    return this.http.post<
      DailyPlanningApiRoutesDto['createPlanningQuantity']['return']
    >(`${this.urlRoute}/day/create`, body);
  }

  getOneRecordById(
    id: number
  ): Observable<
    DailyPlanningApiRoutesDto['getPlanningQuantityById']['return']
  > {
    return this.http.get<
      DailyPlanningApiRoutesDto['getPlanningQuantityById']['return']
    >(`${this.urlRoute}/quantity/${id}`);
  }

  updateOneRecordByWorkOrderId(
    id: number,
    body: DailyPlanningApiRoutesDto['updateOnePlanningQuantityByWorkOrderId']['body']
  ): Observable<
    DailyPlanningApiRoutesDto['updateOnePlanningQuantityByWorkOrderId']['return']
  > {
    return this.http.patch<
      DailyPlanningApiRoutesDto['updateOnePlanningQuantityByWorkOrderId']['return']
    >(`${this.urlRoute}/quantity/workOrder/${id}`, body);
  }

  updateOneRecordById(
    id: number,
    body: DailyPlanningApiRoutesDto['updateOnePlanningQuantityById']['body']
  ): Observable<
    DailyPlanningApiRoutesDto['updateOnePlanningQuantityById']['return']
  > {
    return this.http.patch<
      DailyPlanningApiRoutesDto['updateOnePlanningQuantityById']['return']
    >(`${this.urlRoute}/quantity/${id}`, body);
  }

  getAllRecords(
    query: DailyPlanningApiRoutesDto['getAllPlanningQuantity']['body']
  ): Observable<DailyPlanningApiRoutesDto['getAllPlanningQuantity']['return']> {
    const {
      startDate,
      endDate,
      workOrderId,
      assemblyItemTitle,
      departmentName,
      workOrderTransactionNumber,
      isFinished,
    } = query;

    let params = new HttpParams();

    if (startDate) {
      params = params.append('startDate', startDate.toISOString());
    }
    if (endDate) {
      params = params.append('endDate', endDate.toISOString());
    }
    if (workOrderId) {
      params = params.append('workOrderId', workOrderId);
    }
    if (assemblyItemTitle) {
      params = params.append('assemblyItemTitle', assemblyItemTitle);
    }
    if (departmentName) {
      params = params.append('departmentName', departmentName);
    }
    if (workOrderTransactionNumber) {
      params = params.append(
        'workOrderTransactionNumber',
        workOrderTransactionNumber
      );
    }
    if (isFinished != undefined) {
      const val = isFinished ? 'true' : 'false';
      params = params.append('isFinished', val);
    }

    return this.http.get<
      DailyPlanningApiRoutesDto['getAllPlanningQuantity']['return']
    >(`${this.urlRoute}/quantity/all`, {
      params,
    });
  }
}
